<template>
  <div class="x-tablelist-view" data-automation="keyList">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @change="change"
      @search="seach"
      @del="delPoint"
      @history="history"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :emptyText="$t('HT.nodata')"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        @changeSize="changeSize"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>
<script>
import delPoint from './template/delPoint.vue';
export default {
  data() {
    return {
      layout: [
        // 搜索项配置
        {
          type: 'select',
          placeholder: '环境',
          options: [
            {
              value: true,
              label: '国内'
            },
            {
              value: false,
              label: '国外'
            }
          ],
          key: 'local',
          event: 'change'
        },
        {
          type: 'date',
          key: 'moment',
          time: true
        },
        {
          type: 'input',
          key: 'imei',
          placeholder: '请输入imei进行搜索'
        }
        // {
        //     type: 'button',
        //     text: '操作历史',
        //     event: 'history',
        //     right: true
        // }
      ],
      columns: [
        // 表头数据
        {
          label: 'IMEI',
          prop: 'imei',
          tooltip: true
        },
        {
          label: 'gps时间',
          prop: 'gps_time',
          tooltip: true
        },
        {
          label: '方向',
          prop: 'direction',
          tooltip: true
        },
        {
          label: '纬度',
          prop: 'lat',
          tooltip: true
        },
        {
          label: '经度',
          prop: 'lng',
          tooltip: true
        }
      ],
      filter: {
        // 查询参数
        local: '', // 环境
        imei: '', // imei
        moment: '', // 时间
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },

  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getTrack(params) {
      this.$api.log.getTrack(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 搜索
     */
    seach() {
      if (this.filter.local === '') {
        this.$uxModal.hide();
        this.$uxMessage.warning('请选择环境');
        return;
      }
      if (this.filter.moment == '') {
        this.$uxModal.hide();
        this.$uxMessage.warning('请选择时间');
        return;
      }
      if (this.filter.imei == '') {
        this.$uxModal.hide();
        this.$uxMessage.warning('请输入imei号');
        return;
      } else {
        this.filter.page = 1;
        this.getTrack(this.filter);
      }
    },

    /**
     * 删除
     */
    delPoint() {
      if (this.tableData.totalSize == 0) {
        this.$uxMessage.warning('请查询后点击');
      } else {
        this.$uxModal.show({
          title: '删除定位点',
          content: (h) => {
            return h(delPoint, {});
          },
          confirm: (data) => {
            this.delList(data);
          }
        });
      }
    },

    /**
     * 删除
     * @param {Object} {imei local moment reason}
     */
    delList(params) {
      let data = {
        imei: this.filter.imei,
        local: this.filter.local,
        moment: this.filter.moment,
        reason: params.reason
      };
      this.$uxLoading.show();
      this.$api.log.delTrack(data).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success('删除成功');
          this.getTrack(this.filter);
        }
      });
    },

    /**
     * 操作历史
     */
    history() {
      this.$router.push('/record');
    },

    /**
     * 改变页码
     * @param {Number} page 页码
     */
    change() {
      this.filter.page = 1;
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getTrack(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getTrack(this.filter);
    }
  }
};
</script>
